import { InputProps } from '@procore/core-react/dist/_typedoc/Input/Input.types.json';
import * as React from 'react';
export default {
  InputProps,
  React
};